import PropTypes from "prop-types";
import React from "react";
import {connect} from "react-redux";

class SortSelect extends React.Component {

  static propTypes = {
    "previewSwapping": PropTypes.bool,
    "selectedFilters": PropTypes.array.isRequired,
    "sort": PropTypes.func.isRequired,
    "sorts": PropTypes.array.isRequired
  };

  static defaultProps = {"previewSwapping": false}

  constructor (props) {
    super(props);

    this.state = {"expanded": false};
  }

  handleClick = (selectedSort) => {
    const {sort} = this.props;
    const currentSort = this.selectedSortName();
    this.collapse();

    // Featured isn't a real sort, so we instead undo the current sort.
    if (selectedSort === "Featured" || selectedSort === "Wishlisted") {
      sort(currentSort);
    // Only apply filter if it's different from previous selection.
    } else if (currentSort !== selectedSort) {
      sort(selectedSort);
    }
  }

  expand = () => {
    this.setState({"expanded": true});
  }

  collapse = () => {
    this.setState({"expanded": false});
  }

  toggleDropdown = () => {
    const {expanded} = this.state;
    this.setState({"expanded": !expanded});
  }

  selectedSortName = () => {
    const {selectedFilters, previewSwapping} = this.props;
    const selectedSort = selectedFilters.find(filter => filter.key.indexOf("sort") === 0);
    // eslint-disable-next-line no-nested-ternary
    const selectedSortName = selectedSort ? selectedSort.displayName : previewSwapping ? "Wishlisted" : "Featured";

    return selectedSortName;
  }

  render () {
    const {expanded} = this.state;
    const {sorts} = this.props;
    const selectedSortName = this.selectedSortName();
    const sortList = sorts.map(sort => sort.displayName);

    return (
      <div className="jewelry-sort">
        <div className="jewelry-sort-label ttcommons-demibold">
          Sort by:
        </div>
        <div
          className="jewelry-sort-dropdown"
          onBlur={this.collapse}
          tabIndex="-1"
        >
          <div
            className={`jewelry-sort-select ${expanded
              ? "jewelry-sort-select-expanded"
              : "jewelry-sort-select-collapsed"}`}
            onClick={this.toggleDropdown}
          >
            <div className="jewelry-sort-select-words">
              {selectedSortName}
            </div>
            <div className={expanded ? "arrow-up" : "arrow-down"} />
          </div>
          {expanded &&
            sortList.map(displayName =>
              <div
                className={`sort-option ${displayName === selectedSortName && "ttcommons-demibold"}`}
                key={displayName}
                onClick={() => this.handleClick(displayName)} // eslint-disable-line react/jsx-no-bind
              >
                {displayName}
              </div>)}
        </div>
      </div>
    );
  }
}

const mapStoreToProps = state => ({"selectedFilters": state.selectedFilters || []});

export default connect(mapStoreToProps)(SortSelect);
